export default __webpack_public_path__ + "static/media/Python-removebg-preview.ed99eb56.png";